import React from 'react';

export default function EduTechResult() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <p className="text-gray-500">Edutech result page not yet implemented.</p>
    </div>
  );
}
